import {N0SsrAvailability} from "@models/responses/ssr-availability-response.model";
import {
  N0PassengerSsrsUpdate,
  N0SsrPassengerUpdateRequest,
  N0SsrUpdate
} from "@models/requests/ssr-passenger-update-request.model";
import {SaveOnlineLabels} from "@models/cms/extras.model";
import {tryParseJson} from "@utils/json-utils";

export function getSsrPriceForSummary({
    selection,
    passenger,
    ssr,
    ssrAvailability,
  } : {
  selection: N0SsrPassengerUpdateRequest,
  passenger: N0PassengerSsrsUpdate,
  ssr: N0SsrUpdate,
  ssrAvailability: N0SsrAvailability | null,
  },
) {
  const extrasSsr = ssrAvailability?.journeySsrs
    .find((j) => j.journeyKey === selection.journeyKey)
    ?.extrasSsrs.find(
      (extrasSsr) => extrasSsr.ssrCode === ssr.ssrCode,
    );

  const passengerAvailability = extrasSsr?.passengersAvailability.find(
    (pa) => pa.passengerKey === passenger.passengerKey,
  );

  if (!passengerAvailability) {
    return 0;
  }

  return passengerAvailability.price ?? 0;
}

export function tryParseSaveOnlineLabels(input?: string): SaveOnlineLabels | null {
  if (!input) {
    return null;
  }

  const parsed = tryParseJson(input);

  if (typeof parsed !== 'object' || parsed === null) {
    return null;
  }

  const result: SaveOnlineLabels = {};

  for (const ssrCode in parsed) {
    const airports = parsed[ssrCode];
    if (typeof airports !== 'object' || airports === null) {
      continue;
    }

    result[ssrCode] = {};

    for (const airportCode in airports) {
      const airportLabels = airports[airportCode];
      if (typeof airportLabels !== 'object' || airportLabels === null) {
        continue;
      }

      const labels: { [currency: string]: string } = {};

      for (const currencyLabel in airportLabels) {
        const label = airportLabels[currencyLabel];
        if (typeof label === 'string' && label.length > 0) {
          labels[currencyLabel] = label;
        }
      }

      if (Object.keys(labels).length > 0) {
        result[ssrCode]![airportCode] = labels;
      }
    }
  }

  return Object.keys(result).length > 0 ? result : null;
}
